
import XButton from 'vux/src/components/x-button/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { toast, setLocalInfo, get } from '../../../util'
import { mapState } from 'vuex'
import { imgpUrl } from '../../../config'

export default {
components: {
XButton,
Swiper,
SwiperItem,
Tab,
TabItem
},
data () {
return {
code: '',
list: [],
banner: [],
news: {},
showNews: [],
imgpUrl
}
},
methods: {
search () {
if (this.code === '') {
toast('请输入商品名称或税则号')
return
}

if (/^[\d]{4,10}$/.test(this.code) || /^[\d\\\\.]{5,11}$/.test(this.code)) {
this.$router.push({name: 'tariff', params: { 'code': this.code }})
setLocalInfo('tariffSearchCode', this.code)
this.code = ''
} else {
this.$router.push({name: 'product', params: { 'code': this.code }})
setLocalInfo('productSearchCode', this.code)
this.code = ''
}
},
goDetail (item) {
item.contet = item.cont
item.release = true
this.$router.push({name: 'comArticle', params: {'article': item}})
},
onItemClick (index) {
if (index === 0) {
this.showNews = this.news.rule
} else {
this.showNews = this.news.notice
}
},
},
computed: {
...mapState(['user'])
},
mounted () {

get('home/news_list').then((res) => {
if (res.data.length > 0) {
this.list = res.data
}
})

get('home/banner_list').then((res) => {
if (res.status === 1) {
this.banner = res.data
}
})

get('home/info').then((res) => {
if (res.status === 1) {
this.news = res.data
this.showNews = res.data.rule
}
})
}
}



// WEBPACK FOOTER //
// ./src/pages/home/components/main.vue